import { IIconProps } from '../interface';

const SvgCzechRepublic = ({ width = 56, height = 56 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_172_15525)">
      <path
        d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill="#F0F0F0"
      />
      <path
        d="M25.5652 28C25.5652 28 8.21733 47.8029 8.20093 47.799C13.2678 52.866 20.2679 56 28 56C43.4639 56 56 43.4639 56 28H25.5652Z"
        fill="#D80027"
      />
      <path
        d="M8.20099 8.20094C-2.73366 19.1356 -2.73366 36.8643 8.20099 47.799C12.7196 43.2804 17.0654 38.9346 28 28L8.20099 8.20094Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_15525">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCzechRepublic;
